import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import {
    createEnrollmentActivity,
    createEnrollmentVideo,
    createTCC,
    initTestCall,
    listClasses,
    getClasse,
    updateTccs,
    submitTest,
    fetchClass,
    fetchEnrollmentsList,
    fetchStudentEnrollment,
    requestFileUpload,
    updateEnrollmentVideo,
    downloadAttachment,
    withRetry,
    returnValidTccAndTcc,
    validSubmit,
} from '../../utils/common-functions';
import { userInformation } from '../login/login.saga';
import { mode, urlRedirectNewEad } from '../../settings';
import { deepMerge } from '../../utils/object-utils';
import moment from 'moment/moment';

function* enrollmentsList() {
    try {
        const enrollments = yield call(withRetry(fetchEnrollmentsList));
        yield put({ type: actions.ENROLLMENT_LIST_FETCHED, payload: enrollments.data });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'As matrículas do aluno não puderam ser carregadas. Tente recarregar a página' } });
    }
}

function* fetchOneClass({ payload: classId }, params = {}) {
    let hasAttach = false;
    try {
        if (!params.shallow) {
            params._ = Date.now();
        }
        const { classesNewEad = [] } = yield select(({ App })=> App);
        const currentClasseObject = classesNewEad.find(e=> classId === e.class_id);

        const response = yield call(withRetry(fetchClass), classId, params);
        yield put({ type: actions.SET_CURRENT_CLASSE, payload: classId });
        const { data } = yield call(getClasse, classId);
        yield put({ type: actions.SET_CURRENT_TCCS, payload: data });

        if (!(response.data && response.data.cards)) {
            return;
        }

        if (((currentClasseObject && currentClasseObject.tests) && currentClasseObject.tests.length > 0)) {
            response.data.cards.push({
                title: 'Testes Online',
                expired: undefined,
                description: 'Acesse aqui o sistema de avaliações do EAD Febracis. Faça um teste online e envie os documentos obrigatórios para você obter o seu certificado.',
                id: 'online-test',
                picture: 'https://cdn.scisapp.com/downloads/images/1519586414852896642a1c015111c.jpeg',
                items:[
                    {
                        items: [
                            {
                                activityContentType: 'JUST_ATTACHMENT',
                                allowsAttachments: 'true',
                                end: '2018-05-16T17:22:09.456Z',
                                id: 'cjpk90688003s01p1atf0m5rn',
                                init: '2018-05-16T16:22:09.456Z',
                                type: 'ACTIVITY',
                            },
                        ],
                        title: 'RELATÓRIO DO CICO COMPLETO DE SESSÕES FORMAÇÃO EM COACHING / COACH',
                    },
                    {
                        items: [
                            {
                                activityContentType: 'JUST_ATTACHMENT',
                                allowsAttachments: 'true',
                                end: '2018-05-16T17:22:09.456Z',
                                id: 'cjpk90688003u01p1frc9u8te',
                                init: '2018-05-16T16:22:09.456Z',
                                type: 'ACTIVITY',
                            },
                        ],
                        title: 'RELATÓRIO DO CICO COMPLETO DE SESSÕES FORMAÇÃO EM COACHING / COACHEE',
                    },
                    {
                        items: [
                            {
                                activityContentType: 'TEXT_AND_ATTACHMENT',
                                id: 'cjpk90688003u01p1frc9u8te',
                                type: 'ACTIVITY',
                            },
                        ],
                        title: 'COACHING PROFESSIONAL',
                    },
                ],
            });
        }
        const Classes = yield select(({ App }) => App.student );

        let knowledge = { ...response.data };
        knowledge.cards.map( e => {
            if (e.id === 'anexos' ) {
                if (e.items && e.items.length > 0 ) {
                    e.items[e.items.length - 1].items = Classes[knowledge.classId] ? Classes[knowledge.classId].attachments : [];
                } else {
                    if ( Classes[knowledge.classId] && Classes[knowledge.classId].attachments.length > 0 ) {
                        e.items = [{
                            title: 'Lista de anexos',
                            items: Classes[knowledge.classId].attachments,
                        }];
                    }
                }
                hasAttach = true;
            }
            return e;
        });

        if ( !hasAttach && Classes[knowledge.classId] && Classes[knowledge.classId].attachments && Classes[knowledge.classId].attachments.length > 0 ) {
            let attach = { id: 'anexos', title: 'Anexos', picture: null, description: null, items: [{ title: 'Lista de anexos', items: Classes[knowledge.classId].attachments ? Classes[knowledge.classId].attachments : [] }] };
            knowledge.cards.push(attach);
        }
        yield put({ type: actions.CLASS_FETCHED, payload: knowledge });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: `A turma ${classId} não pôde ser carregada. Tente recarregar a página` } });
    }
}

function* fetchClasses() {
    yield put ({ type: actions.TOGGLE_LOADING_COURSES, payload: true });
    const data = yield select(({ App }) => App.enrollments);
    try {
        // yield all(data.map(datum => call(fetchOneClass, { payload: datum.classId }, { shallow: true })));
        for (let datum of data) {
            yield call(fetchOneClass, { payload: datum.classId }, { shallow: true });
        }
        yield classesInformation();
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'As turmas não puderam ser carregadas. Tente recarregar a página' } });
    } finally {
        yield put ({ type: actions.TOGGLE_LOADING_COURSES, payload: false });
    }
}

function* fetchOneEnrollment(classId) {
    try {
        const response = yield call(withRetry(fetchStudentEnrollment), classId);
        return response.data;
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: `Os dados do aluno para a turma ${classId} não puderam ser carregados. Tente recarregar a página` } });
        return null;
    }
}

function* fetchStudentEnrollments() {
    const data = yield select(({ App }) => App.enrollments);
    try {
        let enrollments = [];

        for (let datum of data) {
            enrollments.push(
                yield call(fetchOneEnrollment, datum.classId),
            );
        }

        // const enrollments = yield all(data.map(datum => call(fetchOneEnrollment, datum.classId)));
        yield put({ type: actions.STUDENT_ENROLLMENT_FETCHED, payload: enrollments.filter(e => e) });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Os dados do aluno não puderam ser carregados. Tente recarregar a página' } });
    }
}

function* fetchAppData() {
    yield call(userInformation);
}

function* classesInformation() {
    try {
        const { data } = yield call(listClasses);
        yield put({ type: actions.SET_LIST_CLASSES, payload: data });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: error.message, hidden: mode.isRelease } });
    }
}

function* fetchCoachData() {
    yield call(classesInformation);
    yield call(enrollmentsList);
    yield call(fetchClasses);
    yield call(fetchStudentEnrollments);
    // yield all([call(fetchClasses), call(fetchStudentEnrollments)]);
}

function* initVideoData({ payload }) {
    const currentEnrollment = yield select(({ App }) => App.student[payload.classId]);
    const enrollmentUpdate = { videos: { [payload.videoUrl]: payload.data } };
    const newEnrollment = deepMerge({}, currentEnrollment, enrollmentUpdate);
    try {
        yield call(createEnrollmentVideo, payload.classId, enrollmentUpdate.videos);
        yield put({ type: actions.STUDENT_ENROLLMENT_UPDATED, payload: { classId: payload.classId, value: newEnrollment } });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: error.message, hidden: mode.ALL } });
    }
}

function* updateVideoData({ payload }) {
    const currentEnrollment = yield select(({ App }) => App.student[payload.classId]);
    const enrollmentUpdate = { videos: { [payload.videoUrl]: payload.data } };
    const newEnrollment = deepMerge({}, currentEnrollment, enrollmentUpdate);
    try {
        yield call(updateEnrollmentVideo, payload.classId, enrollmentUpdate.videos);
        yield put({ type: actions.STUDENT_ENROLLMENT_UPDATED, payload: { classId: payload.classId, value: newEnrollment } });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: error.message, hidden: mode.ALL } });
    }
}

function* updateActivity({ payload }) {
    yield put({ type: actions.UPDATE_ACTIVITY_STATUS, payload: { classId: payload.classId, id: Object.keys(payload.value)[0], pending: true } });
    const enrollmentUpdate = { activities: payload.value };
    try {
        const response = yield call(withRetry(createEnrollmentActivity), payload.classId, enrollmentUpdate.activities);
        yield put({ type: actions.STUDENT_ACTIVITY_UPDATED, payload: { classId: payload.classId, value: payload.value } });
        yield put({ type: actions.TCCS_PROGRESS_UPDATED, payload: { progresses: response.data, classId: payload.classId } });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Atividade não pôde ser salva. Tente novamente' } });
    }
    yield put({ type: actions.UPDATE_ACTIVITY_STATUS, payload: { classId: payload.classId, id: Object.keys(payload.value)[0], pending: false } });
}

function* uploadFile({ payload }) {
    const { dataUri, cb, mime } = payload;
    try {
        const response = yield requestFileUpload(dataUri, { mime });
        yield call(cb, response.data.uri);
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'O upload falhou. Tente novamente' } });
    }
}

function* uploadFileNewEad({ payload }) {
    try {
        const { dataUri, mime, newFile } = payload;
        const response = yield requestFileUpload(dataUri, { mime });
        const { currentTccs, currentClasse } = yield select(({ App })=> App);

        let oldFiles = currentTccs.attachments || [];
        const newTccs = { ...currentTccs, attachments: [ ...oldFiles, { ...newFile, url: response.data.uri } ] };
        const tccs = returnValidTccAndTcc(newTccs);
        yield call(updateTccs, currentClasse, tccs.validTcc);
        yield put({ type: actions.SET_CURRENT_TCCS, payload: tccs.currentTcc });
        yield put({ type: actions.SET_IS_SAVING_NEW_EAD, payload: false });
    } catch (e) {
        let data = e.response ? e.response.data : undefined;
        yield put({ type: actions.REQUEST_ERROR, payload: { message: data ? data.error_description : 'O upload falhou, arquivo inválido. Tente novamente' } });
        yield put({ type: actions.SET_IS_SAVING_NEW_EAD, payload: false });
    }
}

function* submitTCC({ payload }) {
    yield put({ type: actions.LOADING_TCC_SUBMISSION, payload: { tccLoading: true } });
    const currentEnrollment = yield select(({ App }) => App.student[payload.classId]);
    const enrollmentUpdate = {
        [payload.tccId]: {
            submitted: moment().toISOString(),
        },
    };
    const newEnrollment = deepMerge({}, currentEnrollment, { tccs: enrollmentUpdate });
    try {
        yield call(createTCC, payload.classId, enrollmentUpdate);
        yield put({ type: actions.STUDENT_ENROLLMENT_UPDATED, payload: { classId: payload.classId, value: newEnrollment } });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: error.message, hidden: mode.ALL } });
    }
    yield put({ type: actions.LOADING_TCC_SUBMISSION, payload: { tccLoading: false } });
}

function* updateModuleDates({ payload }) {
    const currentEnrollment = yield select(({ App }) => App.student[payload.classId]);
    const enrollmentUpdate = {
        [payload.tccId]: {
            firstModEnd: payload.firstModEnd,
            secondModEnd: payload.secondModEnd,
            masterEnd: payload.masterEnd,
        },
    };
    const newEnrollment = deepMerge({}, currentEnrollment, { tccs: enrollmentUpdate });
    try {
        yield call(createTCC, payload.classId, enrollmentUpdate);
        yield put({ type: actions.STUDENT_ENROLLMENT_UPDATED, payload: { classId: payload.classId, value: newEnrollment } });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: error.message, hidden: mode.ALL } });
    }
}

function* downloadAttach({ payload }) {
    let newTab = window.open('', 'newWindow');
    const { classId, fileId } = payload;
    try {
        const { data } = yield downloadAttachment( classId, fileId );
        newTab.location.href = data.url;
        if ( newTab === null || typeof (newTab) === 'undefined') {
            alert('Por favor, habilite seu navegador para receber popup e tente novamente');
        } else {
            newTab.focus();
        }
    } catch (error) {
        newTab.close();
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: error.message, hidden: mode.ALL } });
    }
}

function* updateTccsNewEad({ payload }) {
    const { currentTccs, currentClasse, classesNewEad = [] } = yield select(({ App })=> App);
    const request = { ...currentTccs, ...payload };
    const tccs = returnValidTccAndTcc(request);
    yield put({ type: actions.SET_LOADING_TESTS_ONLINE, payload: true });
    try {
        yield call(updateTccs, currentClasse, tccs.validTcc);
        yield put({ type: actions.SET_CURRENT_TCCS, payload: tccs.currentTcc });
    } catch (err) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error: err, message: 'error ao salvar dados', hidden: mode.ALL } });
        yield put({ type: actions.SET_LOADING_TESTS_ONLINE, payload: false });
        return;
    }
    try {
        const currentClasseObject = classesNewEad.find(e=> currentClasse === e.class_id);
        let isValid = validSubmit(currentTccs, currentClasseObject ? currentClasseObject.tests : []);
        if (isValid) {
            yield call(submitTest, currentClasse);
            yield put({ type: actions.SET_CURRENT_TCCS, payload: { ...tccs.currentTcc, submitted: true, submitted_at: new Date().toISOString() } });
            yield classesInformation();
        } else {
            yield put({ type: actions.REQUEST_ERROR, payload: { error: new Error(), message: 'campos obrigatórios não preenchidos', hidden: mode.ALL } });
        }
    } catch (err) {
        yield put({ type: actions.SET_LOADING_TESTS_ONLINE, payload: false });
        yield put({ type: actions.REQUEST_ERROR, payload: { error: err, message: 'error ao fazer submit dos dados', hidden: mode.ALL } });
    }
    yield put({ type: actions.SET_LOADING_TESTS_ONLINE, payload: false });

}

function* uploadAttachmentsNewEad({ payload }) {
    try {
        const { currentTccs, currentClasse } = yield select(({ App })=> App);
        const request = { ...currentTccs, attachments: payload };
        const tccs = returnValidTccAndTcc(request);
        yield call(updateTccs, currentClasse, tccs.validTcc);
        yield put({ type: actions.SET_CURRENT_TCCS, payload: tccs.currentTcc });
        yield put({ type: actions.SET_IS_SAVING_NEW_EAD, payload: false });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: error.message, hidden: mode.ALL } });
        yield put({ type: actions.SET_IS_SAVING_NEW_EAD, payload: false });
    }
}

function* initTest({ payload }) {
    try {
        const { currentClasse, userId } = yield select(({ App })=> App);
        const url = `${urlRedirectNewEad}?userId=${userId}`;

        try {
            yield call(initTestCall, { class_id: currentClasse, test_type: payload });
        } catch (e) {
            if (e.response.status !== 409) {
                throw e;
            }
        }

        window.open(url);
    } catch (error) {
        let message = (error.response && error.response.data ) && error.response.data.error_description ? error.response.data.error_description : error.message;
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: message, hidden: mode.ALL } });
    } finally {
        yield put({ type: actions.DISABLED_REDIRECT, payload: false });
    }
}

const initialState = Object.freeze({
    finish_second_module_date: null,
    finish_first_module_date: null,
    finish_master_date: null,
    coach_name: null,
    attachments: [],
});

function* updateValueTcc({ payload }) {
    try {
        const { currentTccs, currentClasse } = yield select(({ App })=> App);
        const request = { ...initialState, ...currentTccs, ...payload };
        const tccs = returnValidTccAndTcc(request);
        yield call(updateTccs, currentClasse, tccs.validTcc);
        yield put({ type: actions.SET_CURRENT_TCCS, payload: tccs.currentTcc });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: 'error em salvar os dados', hidden: mode.ALL } });
    }
}

export default function* app() {
    yield takeLatest(actions.ASYNC_FETCH_APP_DATA, fetchAppData);
    yield takeLatest(actions.ASYNC_FETCH_COACH_DATA, fetchCoachData);
    yield takeEvery(actions.ASYNC_UPDATE_VIDEO_DATA, updateVideoData);
    yield takeEvery(actions.ASYNC_INIT_VIDEO_DATA, initVideoData);
    yield takeEvery(actions.ASYNC_UPDATE_ACTIVITY, updateActivity);
    yield takeEvery(actions.UPLOAD_FILE, uploadFile);
    yield takeEvery(actions.ASYNC_SUBMIT_TCC, submitTCC);
    yield takeEvery(actions.ASYNC_UPDATE_MODULE_DATES, updateModuleDates);
    yield takeLatest(actions.ASYNC_FETCH_CLASS, fetchOneClass);
    yield takeEvery(actions.ASYNC_DOWNLOAD_ATTACH, downloadAttach);
    yield takeEvery(actions.ASYNC_UPDATE_TCCS_DATES, updateTccsNewEad);
    yield takeEvery(actions.ASYNC_UPLOAD_FILE_NEW_EAD, uploadFileNewEad);
    yield takeEvery(actions.ASYNC_UPLOAD_ATTACHMENTS, uploadAttachmentsNewEad);
    yield takeEvery(actions.ASYNC_INIT_TEST, initTest);
    yield takeEvery(actions.ASYNC_UPDATE_VALUE_TCC, updateValueTcc);
}



// WEBPACK FOOTER //
// ./src/components/app/app.saga.js